let mulberrySelectors = {
  pdpBody: ".c-product-info__body",
  pdpForm: "form[action='"+window.theme.routes.cart_add_url+"']",
};

async function removeAndSyncWarranties(reloadCart = true) {
  await fetch(window.theme.routes.cart_url+".js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      mulberryShop
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then((newCart) => {
          mulberryShop.cart
            .syncQuantities(newCart) // Sync Quantities Second
            .then((content) => {
              if (reloadCart) {
                $(document).trigger("Cart:update");
              }
              $(document).trigger("Cart:set", content);
              var intervalCount = 0;
              var intervalID = setInterval(function () {
                mulberryShop.cart.render();

                if (++intervalCount === 3) {
                  window.clearInterval(intervalID);
                }
              }, 750);
            });
          // console.log("remove and sync cart", newCart);
        });
    });
  });
}

async function mulberryInit() {
  if (!window.Shopify.designMode && !!window.ShopifyAnalytics) {
    let response = await mulberryShop.getProductData(
      mulberryShop.getProductUrl()
    );
    let product = response.product;
    text = $(".js-option-selector option:selected")
      .first()
      .text()
      .replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    let selectedVariant = product.variants.find(
      (i) =>
        i.id == window.ShopifyAnalytics.meta.selectedVariantId || i.title == text
    );
    window.selectedVariantName = selectedVariant.title;
    const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product,
    });

    const { settings } = mulberry.core;
    let selectedOffer;

    let pdpInline = await mulberry.inline.init({
      layout: { input: "dropdown" },
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-inline-container",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          selectedOffer = warranty.offer;
        } else {
          selectedOffer = null;
        }
      },
    });

    $(".o-select__container").click(async function () {
      selectedOffer = null;
      text = $(".js-option-selector option:selected")
        .first()
        .text()
        .replace(/^\s+|\s+$|\s+(?=\s)/g, "");
      selectedVariant = product.variants.find(
        (i) =>
          i.id == window.ShopifyAnalytics.meta.selectedVariantId ||
          i.title == text
      );

      newVariantName = selectedVariant.title;
      if (newVariantName === window.selectedVariantName) {
        return;
      }
      window.selectedVariantName = selectedVariant.title;
      if (selectedVariant) {
        const offers = await mulberry.core.getWarrantyOffer({
          id: selectedVariant.id,
          title: product.title,
          price: selectedVariant.price,
          detail: product,
        });

        pdpInline.updateOffer(offers);
      }
    });

    $(mulberrySelectors.pdpBody)
      .find(mulberrySelectors.pdpForm)
      .submit(async function () {
        if (offers.length === 0) {
          return;
        }

        if (selectedOffer) {
          setTimeout(async function () {
            const result = await mulberryShop.getWarrantyVariant(selectedOffer);
            await mulberryShop.addWarrantyToCart(
              result.shopify_variant_id,
              { title: product.title, variantId: selectedVariant.id },
              selectedOffer
            );
            removeAndSyncWarranties(false);
          }, 250);
        } else {
          removeAndSyncWarranties(false);
        }
      });
  }
}

document.addEventListener("mulberry-shopify:warranty-added", () => {
  removeAndSyncWarranties();
});

document.addEventListener("mulberry-shopify:loaded", async () => {
  setupAjaxListeners();
  if (document.location.href.search("products/") !== -1) {
    mulberryInit();
  }
  await mulberryShop.cart.init();
  mulberryShop.cart.render();
});

function setupAjaxListeners() {
  // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
  // Since we cant create globals we test for the XMLHttpRequest overwrite
  if (typeof XMLHttpRequest.prototype.mbOpen === "undefined") {
    // We mock fetch() in order to determine if we should mock then() as well
    var mbFetch = fetch;
    fetch = function () {
      var url = arguments[0];
      var body = "";
      if (arguments.length > 1 && typeof arguments[1].body !== "undefined") {
        body = arguments[1].body;
      }
      var promise = mbFetch.apply(this, arguments);
      if (url && url.indexOf("cart/update") !== -1) {
        //If its a product being added to cart we add a function to track it
        promise = promise.then(function (response) {
          if (response.ok) {
            //trackAjaxAddToCart(body, response.clone().json());
          }
          return response;
        });
      }
      return promise;
    };
  }
  if (typeof XMLHttpRequest.prototype.mbOpen === "undefined") {
    // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
    XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
      var url = arguments[1];
      if (url && url.indexOf("cart/update") !== -1) {
        // We mock the instance's send method if the request is to the "add to the cart" url.
        this.mbSend = this.send;
        this.send = function (value) {
          try {
            if (value) {
              var self = this; // The xhttp request object

              var trackOnSuccess = function () {
                if (self.readyState === 4 && self.status === 200) {
                  removeAndSyncWarranties();
                }
              };

              if (typeof self.addEventListener !== "undefined") {
                self.addEventListener("readystatechange", trackOnSuccess);
              } else {
                if (
                  typeof self.onreadystatechange !== "undefined" &&
                  self.onreadystatechange !== null
                ) {
                  // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                  self.mbOnreadystatechange = self.onreadystatechange;
                  self.onreadystatechange = function () {
                    self.mbOnreadystatechange();
                    trackOnSuccess();
                  };
                } else {
                  // If there is no onreadystatechange callback, we can safely set it.
                  self.onreadystatechange = trackOnSuccess;
                }
              }
            }
          } catch (e) {
            // if something goes wrong tracking the addToCart,
            // we just ignore it and prevent the website from breaking.
            console.log(e);
          }
          this.mbSend(value);
        };
      }
      this.mbOpen.apply(this, arguments);
    };
  }
}
